import React, { useState, useEffect, useRef } from "react";
import { Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import AsteriskSymbol from "../../reusableComponents/AsteriskSymbol";
import Select from "react-select";
import "../../scss/saw.scss";
import {
  formattedNumber,
  // ALPHABET_REGEX,
  // FOUR_DIGIT_NUMBER_REGEX,
  generateYears,
  seasonValues,
  titleCase,
} from "../../utilFunctions";
import { pmfby, REGEX } from "../../consts";
import { fetchDistricts, fetchMandals, fetchStates } from "../apiHelper";
import { toast } from "react-toastify";
import ListsPagination from "./ListsPagination";
import {
  fetchCCEData,
  fetchCropList,
  fetchIUNames,
  groupByLocationAndCrop,
} from "./apiHelper";
import NoDataFound from "../../utilsComponent/noDataFound";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TabComponent from "../../reusableComponents/tab/TabComponent";

const TAB_NAMES = { CCE: "CCE", RWBCIS: "RWBCIS" };

const defaultFieldValues = {
  seasonName: "",
  seasonYear: "",
  state: "",
  district: "",
  mandal: "",
  village: "",
  crop: "",
};
const DEFAULT_PAGE = 0;
const DEFAULT_PAGE_SIZE = 10;
const types = {
  STATE: "state",
  DISTRICT: "district",
  MANDAL: "mandal",
  VILLAGE: "iu",
};

const SawDetails = (props) => {
  const [buttonsStatus, setButtonsStatus] = useState(TAB_NAMES.CCE);
  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [mandalList, setMandalList] = useState([]);
  const [IUList, setIUList] = useState([]);
  const [cropList, setCropList] = useState([]);

  const yearsFrom2023 = generateYears(2023);
  const [firstColHeader, setFirstColHeader] = useState(types.STATE);
  const [fieldNames, setFieldNames] = useState(defaultFieldValues);
  const [searchFields, setSearchFields] = useState(defaultFieldValues);
  const [defaultPagination, setDefaultPagination] = useState({
    page: DEFAULT_PAGE,
    itemsPerPage: DEFAULT_PAGE_SIZE,
  });

  const [showLoader, setShowLoader] = useState(false);

  const [data, setData] = useState();
  const [crumbs, setCrumbs] = useState([]);
  const [stateDataPagination, setStateDataPagination] = useState({
    page: DEFAULT_PAGE,
    itemsPerPage: DEFAULT_PAGE_SIZE,
  });
  const [districtDataPagination, setDistrictDataPagination] = useState({
    page: DEFAULT_PAGE,
    itemsPerPage: DEFAULT_PAGE_SIZE,
  });
  const [mandalDataPagination, setMandalDataPagination] = useState({
    page: DEFAULT_PAGE,
    itemsPerPage: DEFAULT_PAGE_SIZE,
  });

  const [villageDataPagination, setVillageDataPagination] = useState({
    page: DEFAULT_PAGE,
    itemsPerPage: DEFAULT_PAGE_SIZE,
  });

  const stateDataPaginationRef = useRef(stateDataPagination);
  const districtDataPaginationRef = useRef(districtDataPagination);
  const mandalDataPaginationRef = useRef(mandalDataPagination);
  const villageDataPaginationRef = useRef(villageDataPagination);

  useEffect(() => {
    stateDataPaginationRef.current = stateDataPagination;
  }, [stateDataPagination]);

  useEffect(() => {
    districtDataPaginationRef.current = districtDataPagination;
  }, [districtDataPagination]);

  useEffect(() => {
    mandalDataPaginationRef.current = mandalDataPagination;
  }, [mandalDataPagination]);

  useEffect(() => {
    villageDataPaginationRef.current = villageDataPagination;
  }, [villageDataPagination]);

  useEffect(() => {
    // COMMENTING TO HIDE IU LEVEL
    getIUList();
  }, [
    fieldNames.seasonName,
    fieldNames.seasonYear,
    fieldNames.state,
    fieldNames.district,
    fieldNames.mandal,
  ]);

  useEffect(() => {
    getStatesList();
    getCropList();
  }, []);

  useEffect(() => {
    setFirstColHeader(getFirstColHeader());
  }, [searchFields.state, searchFields.district, searchFields.mandal]);

  const getStatesList = async () => {
    const fetchedStates = await fetchStates(pmfby);
    setStatesList(fetchedStates);
  };

  const getCropList = async () => {
    const fetchedCrops = await fetchCropList();
    setCropList(fetchedCrops);
  };
  const getDistrictList = async (state) => {
    const fetchedDistricts = await fetchDistricts(state, pmfby);
    setDistrictList(fetchedDistricts);
  };

  const getMandalList = async (district, state) => {
    if (district && state) {
      const fetchedMandals = await fetchMandals(district, state, pmfby);
      setMandalList(fetchedMandals);
    }
  };

  const getIUList = async () => {
    if (
      fieldNames.seasonName &&
      fieldNames.seasonYear &&
      fieldNames.state &&
      fieldNames.district &&
      fieldNames.mandal
    ) {
      const fetchedIUList = await fetchIUNames({
        state: fieldNames.state,
        year: fieldNames.seasonYear,
        season: fieldNames.seasonName.toUpperCase(),
        district: fieldNames.district,
        mandal: fieldNames.mandal,
      });
      setIUList(fetchedIUList);
    } else {
      setIUList([]);
    }
  };

  const determineFirstColHeader = (
    forAPI,
    searchFields,
    districtName,
    mandalName,
    stateName
  ) => {
    if (mandalName || searchFields.mandal || searchFields.village?.value) {
      return forAPI ? "insuranceUnit" : types.VILLAGE;
    }
    if (districtName || searchFields.district) {
      return types.MANDAL;
    }
    if (stateName || searchFields.state) {
      return types.DISTRICT;
    }
    return types.STATE;
  };

  const getCCEData = async ({
    page,
    itemsPerPage,
    district,
    mandal,
    village,
    searchValues = searchFields,
    state
  } = {}) => {
    setShowLoader(true);
    const stateName = state ?? searchValues.state
      ? [state ?? searchValues.state]
      : null;
    const districtName =
      district ?? searchValues.district
        ? [district ?? searchValues.district]
        : null;
    const mandalName =
      mandal ?? searchValues.mandal ? [mandal ?? searchValues.mandal] : null;
    const insuranceUnitCode =
      village ?? searchValues.village?.value
        ? [village ?? searchValues.village.value]
        : null;
    const payload = {
      pagination: {
        page: page ?? defaultPagination.page,
        pageSize: itemsPerPage ?? defaultPagination.itemsPerPage,
      },
      filter: {
        stateName: stateName,
        year: [searchValues.seasonYear],
        seasonName: [searchValues.seasonName?.toUpperCase()],
        districtName: districtName,
        mandalName: mandalName,
        insuranceUnitCode: insuranceUnitCode,
        cropName: searchValues.crop ? [searchValues.crop] : null,
      },
      sort: {
        by:
          determineFirstColHeader(
            true,
            searchValues,
            districtName,
            mandalName,
            stateName
          ) + "Name",
        order: "asc",
      },
    };
    try {
      const cceData = await fetchCCEData(payload);
      if (cceData.status === "FAILURE") {
        toast.error(cceData.errors[0]?.message);
        setData();
        return;
      }
      let crumbsArray = [];
      if (!state && searchValues.state) {
        crumbsArray.push({
          label: searchValues.state,
          handleClick: () => {
            setCrumbs((prev) => [prev[0]]);
            getCCEData({
              district: null,
              mandal: null,
              village: null,
              searchValues: {
                ...searchValues,
                district: null,
                mandal: null,
                village: null,
              },
              page: districtDataPaginationRef.current.page,
              itemsPerPage: districtDataPaginationRef.current.itemsPerPage,
            });
            setDefaultPagination({
              page: districtDataPaginationRef.current.page,
              itemsPerPage: districtDataPaginationRef.current.itemsPerPage,
            });

            setSearchFields((prev) => ({
              ...prev,
              district: null,
              mandal: null,
            }));
            setMandalDataPagination({
              page: DEFAULT_PAGE,
              itemsPerPage: DEFAULT_PAGE_SIZE,
            });
            setVillageDataPagination({
              page: DEFAULT_PAGE,
              itemsPerPage: DEFAULT_PAGE_SIZE,
            });
          },
        })
      }
      if (!district && searchValues.district) {
        crumbsArray.push({
          label: searchValues.district,
          handleClick: () => {
            setSearchFields({ ...searchValues, mandal: null });
            setCrumbs((prev) => [prev[0], prev[1]]);
            getCCEData({
              searchValues: {
                ...searchValues,
                mandal: null,
                village: null,
              },
              page: mandalDataPaginationRef.current.page,
              itemsPerPage: mandalDataPaginationRef.current.itemsPerPage,
            });
            setDefaultPagination({
              page: mandalDataPaginationRef.current.page,
              itemsPerPage: mandalDataPaginationRef.current.itemsPerPage,
            });
            setVillageDataPagination({
              page: DEFAULT_PAGE,
              itemsPerPage: DEFAULT_PAGE_SIZE,
            });
          },
        });
      }
      if (!mandal && searchValues.mandal) {
        crumbsArray.push({
          label: searchValues.mandal,
          handleClick: () => {
            setSearchFields({ ...searchValues, village: null });
            setDefaultPagination({
              page: villageDataPaginationRef.current.page,
              itemsPerPage: villageDataPaginationRef.current.itemsPerPage,
            });
            getCCEData({
              searchValues: {
                ...searchFields,
                village: null,
              },
              page: villageDataPaginationRef.current.page,
              itemsPerPage: villageDataPaginationRef.current.itemsPerPage,
            });
          },
        });
      }
      if (!village && searchValues.village?.value) {
        crumbsArray.push({
          label: searchValues.village?.label,
        });
      }
      setSearchFields({
        ...searchValues,
        state: !searchValues.state
          ? state || searchValues.state || null
          : searchValues.state,
        district: !searchValues.district
          ? district || searchValues.district || null
          : searchValues.district,
        mandal: !searchValues.mandal
          ? mandal || searchValues.mandal || null
          : searchValues.mandal,
      });

      if (!(state || district || mandal || village)) {
        setCrumbs(crumbsArray);
      }
      cceData.data.cceData = groupByLocationAndCrop(cceData.data.cceData);
      setData(cceData.data);
      setFirstColHeader(
        determineFirstColHeader(false, searchValues, districtName, mandalName, stateName)
      );
    } catch (error) {
      console.error("Error in cceData:", error);
    } finally {
      setShowLoader(false);
    }
  };

  const toggleRow = (selectedValue, selectedLabel) => {
    if (selectedValue) {
      if (!searchFields.state) {
        getCCEData({
          state: selectedValue,
          searchValues: {
            ...searchFields,
            district: null,
            mandal: null,
            village: null,
          },
          page: DEFAULT_PAGE,
          itemsPerPage: DEFAULT_PAGE_SIZE,
        });
        setCrumbs((prev) => [
          {
            label: selectedValue,
            handleClick: () => {
              setSearchFields((prev) => ({
                ...prev,
                district: null,
                mandal: null,
                village: null,
              }));
              setCrumbs((prev) => [prev[0]]);
              setDefaultPagination({
                page: districtDataPaginationRef.current.page || DEFAULT_PAGE,
                itemsPerPage:
                  districtDataPaginationRef.current.itemsPerPage ||
                  DEFAULT_PAGE_SIZE,
              });
              getCCEData({
                state: selectedValue,
                searchValues: {
                  ...searchFields,
                  district: null,
                  mandal: null,
                  village: null,
                },
                page: districtDataPaginationRef.current.page || DEFAULT_PAGE,
                itemsPerPage:
                  districtDataPaginationRef.current.page || DEFAULT_PAGE_SIZE,
              });
            },
          },
        ]);
      } else if (!searchFields.district) {
        getCCEData({
          district: selectedValue,
          searchValues: {
            ...searchFields,
            mandal: null,
            village: null,
          },
          page: DEFAULT_PAGE,
          itemsPerPage: DEFAULT_PAGE_SIZE,
        });
        setCrumbs((prev) => [
          ...prev,
          {
            label: selectedValue,
            handleClick: () => {
              setSearchFields((prev) => ({
                ...prev,
                mandal: null,
                village: null,
              }));
              setCrumbs((prev) => [prev[0], prev[1]]);
              setDefaultPagination({
                page: mandalDataPaginationRef.current.page || DEFAULT_PAGE,
                itemsPerPage:
                  mandalDataPaginationRef.current.itemsPerPage ||
                  DEFAULT_PAGE_SIZE,
              });
              getCCEData({
                district: selectedValue,
                searchValues: {
                  ...searchFields,
                  mandal: null,
                  village: null,
                },
                page: mandalDataPaginationRef.current.page || DEFAULT_PAGE,
                itemsPerPage:
                  mandalDataPaginationRef.current.page || DEFAULT_PAGE_SIZE,
              });
            },
          },
        ]);
      } else if (!searchFields.mandal) {
        getCCEData({
          mandal: selectedValue,
          page: DEFAULT_PAGE,
          itemsPerPage: DEFAULT_PAGE_SIZE,
        });
        setCrumbs((prev) => [
          ...prev,
          {
            label: selectedValue,
            handleClick: () => {
              setSearchFields((prev) => ({ ...prev, village: null }));
              setCrumbs((prev) => [prev[0], prev[1], prev[2]]);
              getCCEData({
                state: searchFields.state,
                district: searchFields.district,
                mandal: selectedValue,
                searchValues: {
                  ...searchFields,
                  village: null,
                },
                page: DEFAULT_PAGE,
                itemsPerPage: DEFAULT_PAGE_SIZE,
              });
            },
          },
        ]);
      } else if (!searchFields.village) {
        getCCEData({
          district: searchFields.district,
          mandal: searchFields.mandal,
          page: DEFAULT_PAGE,
          itemsPerPage: DEFAULT_PAGE_SIZE,
          searchValues: {
            ...searchFields,
            village: { label: selectedLabel, value: selectedValue },
          },
        });
        setCrumbs((prev) => [
          prev[0],
          prev[1],
          prev[2],
          {
            label: selectedLabel,
          },
        ]);
      }
    }
  };

  const handleSubmit = () => {
    if (!fieldNames.seasonName || !fieldNames.seasonYear) {
      toast.error("Please select all required fields.");
      return;
    } else {
      let searchValues = JSON.parse(JSON.stringify(fieldNames));
      setSearchFields(searchValues);
      resetSearchFields(true);
      getCCEData({
        searchValues: searchValues,
        page: DEFAULT_PAGE,
        itemPerPage: DEFAULT_PAGE_SIZE,
      });
    }
  };

  const resetSearchFields = (isSearch = false) => {
    if (!isSearch) {
      setFieldNames(defaultFieldValues);
    }
    setData();
    setFirstColHeader(types.STATE);
    setSearchFields((prev) => ({ ...prev, district: null, mandal: null }));
    setStateDataPagination({
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
    setDistrictDataPagination({
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
    setMandalDataPagination({
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
    setVillageDataPagination({
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
    setDefaultPagination({
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
    setCrumbs([]);
  };

  const setValue = (key, value) => {
    setFieldNames((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const fetchData = (page, itemPerPage, isInitialCall = true) => {
    if (firstColHeader === types.STATE) {
      setStateDataPagination({
        page: page - 1,
        itemsPerPage: itemPerPage,
      });
    } else if (firstColHeader === types.DISTRICT) {
      setDistrictDataPagination({
        page: page - 1,
        itemsPerPage: itemPerPage,
      });
    } else if (firstColHeader === types.MANDAL) {
      setMandalDataPagination({
        page: page - 1,
        itemsPerPage: itemPerPage,
      });
    } else if (firstColHeader === types.VILLAGE) {
      setVillageDataPagination({
        page: page - 1,
        itemsPerPage: itemPerPage,
      });
    }
    setDefaultPagination({ page: page - 1, itemsPerPage: itemPerPage });
    if (!isInitialCall) {
      getCCEData({ page: page - 1, itemsPerPage: itemPerPage });
    }
  };

  const getFirstColHeader = () => {
    if (!searchFields.state) {
      return types.STATE
    }
    else if (!searchFields.district) {
      return types.DISTRICT;
    } else if (!searchFields.mandal) {
      return types.MANDAL;
    } else {
      return types.VILLAGE;
    }
  };

  const handleClickHome = () => {
    setCrumbs([]);
    getCCEData({
      state: null,
      district: null,
      mandal: null,
      village: null,
      searchValues: {
        ...JSON.parse(JSON.stringify(fieldNames)),
        state: null,
        district: null,
        mandal: null,
        village: null,
      },
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
    setDefaultPagination({
      page: stateDataPaginationRef.current.page,
      itemsPerPage: stateDataPaginationRef.current.itemsPerPage,
    });

    setSearchFields((prev) => ({
      ...prev,
      district: null,
      mandal: null,
    }));
    setStateDataPagination({
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
    setDistrictDataPagination({
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
    setMandalDataPagination({
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
    setVillageDataPagination({
      page: DEFAULT_PAGE,
      itemsPerPage: DEFAULT_PAGE_SIZE,
    });
  }

  return (
    <section className="p-4">
      <h1 className="headerclaim">SAW</h1>
      <hr />
      <div>
        <Row>
          <div className="form-group tabs">
            <TabComponent
              activeTab={buttonsStatus}
              tabs={[
                {
                  key: TAB_NAMES.CCE,
                  label: TAB_NAMES.CCE,
                  handleClick: (key) => {
                    setButtonsStatus(key)
                  }
                }
              ]}
            />
            {/* <button
              className={`${
                buttonsStatus === TAB_NAMES.RWBCIS
                  ? "btn btn-success mt-4 mb-4 px-4"
                  : "btn btn-outline-success mt-4 mb-4 px-4"
              }`}
              onClick={() => setButtonsStatus(TAB_NAMES.RWBCIS)}
            >
              {TAB_NAMES.RWBCIS}
            </button> */}
          </div>
        </Row>
      </div>
      <>
        <div
          className="row border rounded pb-3 mt-3"
          style={{ zIndex: 2, position: "relative" }}
        >
          <div className="row">
            <div className="col d-md-flex align-items-center justify-content-around mt-3">
              <div className="col form-group ms-2">
                <label htmlFor="seasonName">
                  Season Name <AsteriskSymbol />
                </label>
                <Select
                  id="seasonName"
                  options={seasonValues || []}
                  classNamePrefix="bg-gray"
                  placeholder="Select Season Name"
                  onInputChange={(inputValue) => {
                    const cleanedValue = inputValue.replace(REGEX.ALPHABET_REGEX, "");
                    return cleanedValue;
                  }}
                  value={
                    fieldNames.seasonName
                      ? seasonValues.find(
                        (seasonName) =>
                          seasonName.value === fieldNames.seasonName
                      )
                      : null
                  }
                  onChange={(data) => {
                    setValue("seasonName", data?.value ?? "");
                  }}
                />
              </div>
              <div className="col form-group ms-2">
                <label htmlFor="yearFrom2023">
                  Year <AsteriskSymbol />
                </label>
                <Select
                  id="yearFrom2023"
                  options={yearsFrom2023}
                  onInputChange={(inputValue) => {
                    const cleanedValue = inputValue.replace(
                      REGEX.FOUR_DIGIT_NUMBER_REGEX,
                      ""
                    );
                    return cleanedValue;
                  }}
                  classNamePrefix="bg-gray"
                  placeholder="Select Year"
                  value={
                    fieldNames.seasonYear
                      ? {
                        label: fieldNames.seasonYear,
                        value: fieldNames.seasonYear,
                      }
                      : null
                  }
                  onChange={(data) => {
                    setValue("seasonYear", data?.value ?? "");
                  }}
                />
              </div>
              <div className="col form-group ms-2">
                <label htmlFor="selectState">
                  State
                </label>
                <Select
                  id="selectState"
                  options={statesList || []}
                  classNamePrefix="bg-gray"
                  placeholder="Select State"
                  value={
                    fieldNames.state
                      ? {
                        label: fieldNames.state,
                        value: fieldNames.state,
                      }
                      : null
                  }
                  onChange={(data) => {
                    if (data) {
                      getDistrictList(data.value);
                    }
                    setValue("state", data?.value ?? "");
                    setValue("district", "");
                    setValue("mandal", "");
                    setValue("village", "");
                  }}
                  isClearable
                />
              </div>
              <div className="col form-group ms-2">
                <label htmlFor="selectDistrict">District</label>
                <Select
                  id="selectDistrict"
                  options={districtList}
                  classNamePrefix="bg-gray"
                  placeholder="Select District"
                  isDisabled={!fieldNames.state}
                  value={
                    fieldNames.district
                      ? {
                        label: fieldNames.district,
                        value: fieldNames.district,
                      }
                      : null
                  }
                  onChange={(data) => {
                    if (data) {
                      getMandalList(data?.value, fieldNames.state);
                    }
                    setValue("district", data?.value ?? "");
                    setValue("mandal", "");
                    setValue("village", "");
                  }}
                  isClearable
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col d-md-flex align-items-center justify-content-around mt-3">
              <div className="col form-group ms-2">
                <label htmlFor="selectMandal">Mandal/ Tehsil/ Block</label>
                <Select
                  id="selectMandal"
                  options={mandalList}
                  classNamePrefix="bg-gray"
                  placeholder="Select Mandal"
                  isDisabled={!fieldNames.district}
                  value={
                    fieldNames.mandal
                      ? {
                        label: fieldNames.mandal,
                        value: fieldNames.mandal,
                      }
                      : null
                  }
                  onChange={(data) => {
                    setValue("mandal", data?.value ?? "");
                    setValue("village", "");
                  }}
                  isClearable
                />
              </div>
              <div className="col form-group ms-2">
                <label htmlFor="selectIUName">IU Name</label>
                <Select
                  id="selectIUName"
                  placeholder="Select IU Name"
                  options={IUList ?? []}
                  onChange={(data) => {
                    setValue("village", data ?? null);
                  }}
                  value={fieldNames?.village || null}
                  classNamePrefix="bg-gray"
                  isClearable={true}
                  isDisabled={
                    !(
                      fieldNames.seasonName &&
                      fieldNames.seasonYear &&
                      fieldNames.state &&
                      fieldNames.district &&
                      fieldNames.mandal
                    )
                  }
                />
              </div>
              <div className="col form-group ms-2">
                <label htmlFor="selectCropName">Crop Name</label>
                <Select
                  id="selectCropName"
                  options={cropList ?? []}
                  classNamePrefix="bg-gray"
                  isClearable={true}
                  onChange={(data) => {
                    setValue("crop", data?.value ?? null);
                  }}
                  value={fieldNames.crop ? {label:fieldNames.crop, value: fieldNames.crop } : null}
                />
              </div>
              <div className="col form-group ms-2"></div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 d-flex align-items-end justify-content-start">
              <div className="form-group">
                <button
                  className="btn btn-success m-3 mb-0 px-4 mt-4"
                  onClick={handleSubmit}
                >
                  Search
                </button>
                <button
                  className="btn btn-outline-success m-3 mb-0 px-4 mt-4"
                  onClick={() => resetSearchFields(false)}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>

        {showLoader ? (
          <LoadingPage />
        ) : (
          <div className="mt-4 ps-0">
            {data?.cceData?.length ? (
              <>
                <div className="crumbs">
                  {crumbs.length ? (
                    <>
                      <i className="fa fa-home fs-4 cursor-pointer blue-text" style={{}} onClick={handleClickHome} /> >
                    </>
                  ) : ""}
                  {crumbs.map((crumb, index) => (
                    <React.Fragment key={index}>
                      {index > 0 ? " > " : " "}
                      <span
                        key={crumb}
                        onClick={() => {
                          crumb?.handleClick &&
                            index !== crumbs.length - 1 &&
                            crumb.handleClick();
                        }}
                        className={`crumbs-text cursor-pointer ${crumb.handleClick && index !== crumbs.length - 1
                            ? "blue-text"
                            : ""
                          }`}
                      >
                        {crumb.label}
                      </span>
                    </React.Fragment>
                  ))}
                </div>
                <table className="table table-bordered align-middle saw-table">
                  <thead className="bg-success sticky-header">
                    <tr>
                      <th rowSpan="2">
                        {firstColHeader === types.VILLAGE
                          ? "IU Name"
                          : firstColHeader === types.MANDAL
                            ? "Mandal / Tehsil / Block"
                            : titleCase(firstColHeader)}
                      </th>
                      <th rowSpan="2">Crop Name</th>
                      <th rowSpan="2">Application Count</th>
                      <th
                        colSpan={firstColHeader === types.VILLAGE ? 4 : 2}
                        className="text-center"
                      >
                        Kshema
                      </th>
                      <th
                        colSpan={firstColHeader === types.VILLAGE ? 3 : 1}
                        className="text-center"
                      >
                        Government
                      </th>
                      <th colSpan="2" className="text-center">
                        Comparison
                      </th>
                    </tr>
                    <tr>
                      <th className="text-center">CCE Count</th>
                      {firstColHeader === types.VILLAGE && (
                        <>
                          <th className="text-center">TY</th>
                          <th className="text-center">AY</th>
                        </>
                      )}
                      <th className="text-center">Amount (₹)</th>
                      {/* <th className="text-center">Count</th> */}
                      {firstColHeader === types.VILLAGE && (
                        <>
                          <th className="text-center">TY</th>
                          <th className="text-center">AY</th>
                        </>
                      )}
                      <th className="text-center">Amount (₹)</th>
                      {/* <th className="text-center">Count</th> */}
                      <th className="text-center">Amount (₹)

                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Government - Kshema</Tooltip>}
                        >
                          <i className="fa fa-info-circle ms-3" />
                        </OverlayTrigger>

                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.cceData?.map((details) => (
                      <React.Fragment key={details[firstColHeader]}>
                        <tr>
                          <td
                            onClick={() => {
                              firstColHeader !== types.VILLAGE
                                &&
                                toggleRow(details[firstColHeader]);
                            }}
                            className={firstColHeader !== types.VILLAGE ? "link" : ""}
                            rowSpan={details.count.length + 1}
                          >
                            {details[firstColHeader]}
                          </td>
                        </tr>
                        {details.count?.map((countDetails, index) => (
                          <tr key={index}>
                            <td>{countDetails.cropName}</td>
                            <td>{formattedNumber(countDetails.applicationCount)}</td>
                            <td className="kshema-bg">{formattedNumber(countDetails.kshemaAyCount)}</td>
                            {firstColHeader === types.VILLAGE && (
                              <>
                                <td className="kshema-bg">{formattedNumber(countDetails.totalGovtTy)}</td>
                                <td className="kshema-bg">{formattedNumber(countDetails.totalKshemaAy)}</td>
                              </>
                            )}
                            <td className="kshema-bg">{formattedNumber(countDetails.kshemaClaimAmount)}</td>
                            {/* <td>{countDetails.govtAyCount == 0 ? "NA" : countDetails.govtAyCount}</td> */}
                            {firstColHeader === types.VILLAGE && (
                              <>
                                <td className="government-bg">{formattedNumber(countDetails.totalGovtTy)}</td>
                                <td className="government-bg">{formattedNumber(countDetails.totalGovtAy)}</td>

                              </>
                            )}
                            <td className="government-bg">{formattedNumber(countDetails.govtClaimAmount)}</td>
                            {/* <td>{countDetails.claimCountDifference == 0 ? "NA" : countDetails.claimCountDifference}</td> */}
                            <td className={`${countDetails.claimAmountDifference && countDetails.claimAmountDifference < 0 ? 'text-danger' : ''}`}>{formattedNumber(countDetails.claimAmountDifference)}</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>

                {firstColHeader === types.STATE && data?.cceData?.length && (
                  <ListsPagination
                    fetchData={fetchData}
                    dataCount={data?.totalCount}
                    defaultItemsPerPage={
                      stateDataPaginationRef.current.itemsPerPage
                    }
                    defaultSelectedPage={stateDataPaginationRef.current.page}
                  />
                )}
                {firstColHeader === types.DISTRICT && data?.cceData?.length && (
                  <ListsPagination
                    fetchData={fetchData}
                    dataCount={data?.totalCount}
                    defaultItemsPerPage={
                      districtDataPaginationRef.current.itemsPerPage
                    }
                    defaultSelectedPage={districtDataPaginationRef.current.page}
                  />
                )}
                {firstColHeader === types.MANDAL && data?.cceData?.length && (
                  <ListsPagination
                    fetchData={fetchData}
                    dataCount={data?.totalCount}
                    defaultItemsPerPage={
                      mandalDataPaginationRef.current.itemsPerPage
                    }
                    defaultSelectedPage={mandalDataPaginationRef.current.page}
                  />
                )}
                {firstColHeader === types.VILLAGE &&
                  data?.cceData?.length &&
                  data?.totalCount > 9 && (
                    <ListsPagination
                      fetchData={fetchData}
                      dataCount={data?.totalCount}
                      defaultItemsPerPage={
                        villageDataPaginationRef.current.itemsPerPage
                      }
                      defaultSelectedPage={
                        villageDataPaginationRef.current.page
                      }
                    />
                  )}
              </>
            ) : (
              <NoDataFound text="No Data Found" />
            )}
          </div>
        )}
      </>
    </section>
  );
};

export default SawDetails;
